var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.25 32.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_bagde") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.88,9.64A11.13,11.13,0,1,1,14.75,20.77,11.14,11.14,0,0,1,25.88,9.64m0-2A13.13,13.13,0,1,0,39,20.77,13.13,13.13,0,0,0,25.88,7.64Z",
    transform: "translate(-12.75 -7.64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.08,40.3a1,1,0,0,1-.42-.09l-7.78-3.56-7.79,3.56a1,1,0,0,1-1-.07,1,1,0,0,1-.46-.84V30a1,1,0,1,1,2,0v7.72l6.79-3.1a1,1,0,0,1,.83,0l6.79,3.1V30a1,1,0,1,1,2,0V39.3a1,1,0,0,1-.46.84A1,1,0,0,1,34.08,40.3Z",
    transform: "translate(-12.75 -7.64)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBadge);
export default __webpack_public_path__ + "static/media/ic_badge.60a786d29c4f2b92a39b822be4ed3b9f.svg";
export { ForwardRef as ReactComponent };